import { css } from 'styled-components'
import { rem } from 'polished'

// Fixed image rail dimensions from the chat card layout spec.
const DESKTOP_IMAGE_WIDTH = 180
const DESKTOP_IMAGE_MIN_HEIGHT = 108
const NARROW_IMAGE_WIDTH = 108
const NARROW_IMAGE_MIN_HEIGHT = 96
const SQUARE_EDGE_RADIUS = '0'

const leftEdgeBorderRadius = (radius: string) => `${radius} ${SQUARE_EDGE_RADIUS} ${SQUARE_EDGE_RADIUS} ${radius}`

export const imageCardFrameStyles = css`
  width: ${rem(DESKTOP_IMAGE_WIDTH)};
  min-width: ${rem(DESKTOP_IMAGE_WIDTH)};
  min-height: ${rem(DESKTOP_IMAGE_MIN_HEIGHT)};
  align-self: stretch;
  border-radius: ${props => leftEdgeBorderRadius(props.theme.borderRadius.L)};

  @container chat-card-list (max-width: 480px) {
    width: ${rem(NARROW_IMAGE_WIDTH)};
    min-width: ${rem(NARROW_IMAGE_WIDTH)};
    min-height: ${rem(NARROW_IMAGE_MIN_HEIGHT)};
  }
`
